/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PickingCriteriaExcel01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const pickingCriteriaExcel01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const pickingCriteriaExcel01UploadLoading = (state, { boolean }) => ({
  ...state,
  uploadIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PickingCriteriaExcel01Types.PICKING_CRITERIA_EXCEL01_SHOW_BATCH_JOB_STATUS_SUCCESS]: pickingCriteriaExcel01ShowBatchJobStatusSuccess,
  [PickingCriteriaExcel01Types.PICKING_CRITERIA_EXCEL01_UPLOAD_LOADING]: pickingCriteriaExcel01UploadLoading
});
